const apiUrl = "https://moodwalkr.com/";
const urlVersion = "/route/v1/driving/";
const apiKey =
  "pk.eyJ1IjoibWFraW5hY29ycHVzIiwiYSI6ImNqY3E4ZTNwcTFta3ozMm80d2xzY29wM2MifQ.Nwl_FHrWAIQ46s_lY0KNiQ";
const endUrlParameter =
  "?overview=false&alternatives=true&steps=true&geometries=geojson&continue_straight=true";
const requestOptions = {
  method: "GET",
  headers: {
    "Content-type": "application/json",
    Accept: "application/json"
  }
};

const checkStatus = response => {
  if (response.status < 200 || response.status >= 300) {
    const error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
  return response;
};

const parseJSON = response => {
  return response.json();
};

export const GetItinerary = (theme, departure, destination) => {
  const request = fetch(
    apiUrl +
      theme +
      urlVersion +
      departure +
      ";" +
      destination +
      endUrlParameter,
    requestOptions
  );
  return request
    .then(checkStatus)
    .then(parseJSON)
    .catch(function(error) {
      console.log("request results failed", error);
    });
};

export const getCheckpoints = (departure, distance, angle) => {
  // Variables and parameters
  const reduction = 0.8; // Street network is not an open space so the distances need to be reduced
  const direction = angle * Math.PI / 180 || Math.random() * 2 * Math.PI;
  const distanceOpposite = distance / Math.PI * reduction; // geographic distance to the point opposite to the starting point
  const degreeKmEquator = 111.2; // Multiply by cos(lat) for the value at the current lat
  const degreeKm = degreeKmEquator * Math.cos(departure[1] * Math.PI / 180);

  const p1 = [];
  p1.push(
    departure[0] +
      distanceOpposite /
        Math.sqrt(2) *
        Math.sin(direction - Math.PI / 4) /
        degreeKm
  );
  p1.push(
    departure[1] +
      distanceOpposite /
        Math.sqrt(2) *
        Math.cos(direction - Math.PI / 4) /
        degreeKm
  );

  const p2 = [];
  p2.push(departure[0] + distanceOpposite * Math.sin(direction) / degreeKm);
  p2.push(departure[1] + distanceOpposite * Math.cos(direction) / degreeKm);

  const p3 = [];
  p3.push(
    departure[0] +
      distanceOpposite /
        Math.sqrt(2) *
        Math.sin(direction + Math.PI / 4) /
        degreeKm
  );
  p3.push(
    departure[1] +
      distanceOpposite /
        Math.sqrt(2) *
        Math.cos(direction + Math.PI / 4) /
        degreeKm
  );

  return [p1, p2, p3];
};

export const GetLoop = (theme, departure, checkpoints) => {
  const request = fetch(
    apiUrl +
      theme +
      urlVersion +
      departure +
      ";" +
      checkpoints.join(";") +
      ";" +
      departure +
      endUrlParameter,
    requestOptions
  );
  return request
    .then(checkStatus)
    .then(parseJSON)
    .catch(function(error) {
      console.log("request results failed", error);
    });
};

// export const GetLoop = (departure, time, distance) => "loopdata";

export const getLocation = (location, boundingbox) =>
  fetch(
    `https://api.mapbox.com/geocoding/v5/mapbox.places/${location}.json?bbox=${
      boundingbox[0][0]
    },${boundingbox[0][1]},${boundingbox[1][0]},${
      boundingbox[1][1]
    }&limit=3&access_token=${apiKey}`
  )
    .then(response => {
      if (response.status !== 200) {
        return false;
      }
      return response
        .json()
        .then(data => (data.features.length ? data.features : false));
    })
    .catch(() => false);

export const GetLabelLocation = coordinates =>
  fetch(
    `https://api.mapbox.com/geocoding/v5/mapbox.places/${coordinates[0]},${
      coordinates[1]
    }.json?&access_token=${apiKey}`
  )
    .then(response => {
      if (response.status !== 200) {
        return false;
      }
      return response
        .json()
        .then(data => (data.features.length ? data.features : false));
    })
    .catch(() => false);



// WEBPACK FOOTER //
// ./src/config/api.js